import { configureStore, PreloadedState } from '@reduxjs/toolkit';
import rootReducer from './store/reducers';

export type AppRootState = ReturnType<typeof rootReducer>;
export function setupStore(preloadedState?: PreloadedState<AppRootState>) {
  return configureStore({
    reducer: rootReducer,
    preloadedState
  });
}

export type RootState = ReturnType<typeof setupStore>;
export type AppDispatch = RootState['dispatch'];
